import React from 'react';
import { FormGroup, ControlLabel, FormControl, HelpBlock} from 'react-bootstrap';
/* 
 * Global tools functions
 */

/**
 * Function to redirect to other page
 * @param {string} page URL to redirect
 */
export function goTo(page){
    window.location = page;
}

/**
 * Function to create a Form group (label & input element)
 * @param {string} id HTML element identifier
 * @param {string} label Text to show
 * @param {type} help
 * @param {type} props Rest of properties of the input element
 * @returns {JSX} Elements to render
 */
export function FieldGroup( { id, label, validation, help, ...props }) {
    return (
            <FormGroup controlId={id} validationState={validation}>
                <ControlLabel>{label}</ControlLabel>
                <FormControl {...props} />
		<HelpBlock>{help}</HelpBlock>
            </FormGroup>
            );
}





// WEBPACK FOOTER //
// ./src/client/GlobalTools.js